import { MutationTree } from 'vuex';

import { RootStateI, ModalPosition } from './state';

const mutations: MutationTree<RootStateI> = {
  setSidebar(state, value: boolean) {
    state.sidebar = value;
    if (typeof window !== 'undefined') {
      localStorage.setItem('sidebarOpen', String(value));
    }
  },
  toggleSidebar(state) {
    state.sidebar = !state.sidebar;
    if (typeof window !== 'undefined') {
      localStorage.setItem('sidebarOpen', String(state.sidebar));
    }
  },
  closeSidebar(state) {
    state.sidebar = false;
    if (typeof window !== 'undefined') {
      localStorage.setItem('sidebarOpen', 'false');
    }
  },
  openNewEventModal(state) {
    const eventsState = (state as RootStateI & { events?: { event?: any; eventTemplateInitialized?: boolean } }).events;
    const hasEventData = !!(eventsState?.event && (
      eventsState.event.id !== 0
      || eventsState.event.title
      || eventsState.event.description
      || eventsState.event.startTime
      || eventsState.event.endTime
    ));

    if (!state.editEventMode && !eventsState?.eventTemplateInitialized && hasEventData) {
      eventsState.event = {
        id: 0,
        calendarId: 0,
        userId: 0,
        title: '',
        description: '',
        startTime: 0,
        endTime: 0,
        createdAt: 0,
        updatedAt: 0,
        recurrenceRule: '',
        icon: '',
        utc: '',
      };
      eventsState.eventTemplateInitialized = false;
    }

    state.newEventModal = true;
  },
  closeNewEventModal(state) {
    state.newEventModal = false;
    state.newEventStartTime = '';
    state.newEventEndTime = '';
    const eventsState = (state as RootStateI & { events?: { event?: any; eventTemplateInitialized?: boolean } }).events;
    if (eventsState) {
      eventsState.event = {
        id: 0,
        calendarId: 0,
        userId: 0,
        title: '',
        description: '',
        startTime: 0,
        endTime: 0,
        createdAt: 0,
        updatedAt: 0,
        recurrenceRule: '',
        icon: '',
        utc: '',
      };
      eventsState.eventTemplateInitialized = false;
    }
  },
  setNewEventTimes(state, payload: { startTime: string; endTime: string } | null) {
    if (payload) {
      state.newEventStartTime = payload.startTime;
      state.newEventEndTime = payload.endTime;
    } else {
      state.newEventStartTime = '';
      state.newEventEndTime = '';
    }
  },
  openEventDetailsModal(state) {
    state.eventDetailsModal = true;
  },
  openPlannerModal(state) {
    state.plannerModal = true;
  },
  closePlannerModal(state) {
    state.plannerModal = false;
  },
  closeEventDetailsModal(state) {
    state.eventDetailsModal = false;
  },
  setEditEventMode(state, value: boolean) {
    state.editEventMode = value;
  },
  setEventModalPosition(state, position: ModalPosition | null) {
    state.eventModalPosition = position;
  },
  setSelectedDate(state, date: string) {
    state.selectedDate = date;
    state.focusDate = date;
  },
  setSelectedEndDate(state, date: string) {
    state.selectedEndDate = date;
  },
  setFocusDate(state, date: string) {
    state.focusDate = date;
  },
  setViewMode(state, mode: 'day' | 'week' | 'labour' | 'month' | 'year') {
    state.viewMode = mode;
  },
  setCalendarRange(
    state,
    payload: {
      viewMode: RootStateI['viewMode'];
      selectedDate: string;
      selectedEndDate: string;
      focusDate?: string;
    },
  ) {
    state.viewMode = payload.viewMode;
    state.selectedDate = payload.selectedDate;
    state.selectedEndDate = payload.selectedEndDate;
    state.focusDate = payload.focusDate ?? payload.selectedDate;
  },
  setPlannerDate(state, date: string) {
    state.plannerDate = date;
  },
  openDayEventsHoverModal(state) {
    state.dayEventsHoverModal = true;
  },
  closeDayEventsHoverModal(state) {
    state.dayEventsHoverModal = false;
    state.hoveredDate = '';
    state.hoverModalPosition = null;
    state.dayEventsHoverModalEvents = [];
  },
  setHoveredDate(state, date: string) {
    state.hoveredDate = date;
  },
  setHoverModalPosition(state, position: ModalPosition | null) {
    state.hoverModalPosition = position;
  },
  setDayEventsHoverModalEvents(state, events: any[]) {
    state.dayEventsHoverModalEvents = events;
  },
};

export {
  mutations,
};
